import React from 'react';
import { RotateCcw, PenSquare } from 'lucide-react';
import { FolderItem } from './FolderItem';
import { useInbox } from '../InboxContext';
import { FOLDERS } from '../mock/mockEmails';
import { Button, Tooltip, TooltipTrigger, TooltipContent, ICON_PX } from '../../../ui';

function FolderSidebar() {
  const { activeFolder, setActiveFolder, folderCounts, actions, startCompose } = useInbox();

  return (
    <nav className="flex flex-col gap-0.5 p-2">
      {/* Compose button */}
      <Button
        variant="create"
        size="sm"
        className="w-full mb-2 gap-1.5"
        onClick={startCompose}
      >
        <PenSquare size={ICON_PX.sm} />
        Compose
      </Button>

      <div className="flex items-center justify-between px-1 mb-1">
        <p className="text-[9px] font-bold text-text-muted uppercase tracking-wider">Folders</p>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={actions.resetState}
              className="flex items-center p-0.5 rounded hover:bg-surface-warm transition-colors text-text-muted hover:text-text-dark"
            >
              <RotateCcw size={10} />
            </button>
          </TooltipTrigger>
          <TooltipContent side="right">Reset demo data</TooltipContent>
        </Tooltip>
      </div>
      {FOLDERS.map((f) => (
        <FolderItem
          key={f.key}
          label={f.label}
          iconName={f.icon}
          count={folderCounts.total[f.key] ?? 0}
          unreadCount={folderCounts.unread[f.key] ?? 0}
          isActive={activeFolder === f.key}
          onClick={() => setActiveFolder(f.key)}
        />
      ))}
    </nav>
  );
}

export { FolderSidebar };
